import { Input, TextArea, styled } from 'tamagui'
import { shadowStandard } from '../../styles'

export const StyledInput = styled(Input, {
  borderRadius: '$2',
  borderColor: '$black',
  backgroundColor: '$white',
  borderWidth: '$0',
  placeholderTextColor: '#757575', //TODO: update to token when tamagui fixes it
  hoverStyle: {
    borderColor: '$black',
  },
  focusStyle: {
    borderColor: '$black',
    outlineWidth: 0,
  },
})

export const StyledTextArea = styled(TextArea, {
  borderRadius: '$2',
  textAlignVertical: 'top',
  borderColor: '$black',
  backgroundColor: '$white',
  borderWidth: '$0',
  placeholderTextColor: '#757575',
  hoverStyle: {
    borderColor: '$black',
  },
  focusStyle: {
    borderColor: '$black',
    outlineWidth: 0,
  },
  ...shadowStandard,
})
